var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBacket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H3.27103L4.08879 4.64354M4.08879 4.64354L4.52687 7.07257L5.03797 9.90644L5.47605 12.3355L6.13318 15.979M4.08879 4.64354H6.95093H8.99533H12.2664H15.1285H17.5818H20.035H22.2839H24.5327L24.0654 7.07257L23.5202 9.90644L23.053 12.3355L22.8972 13.1451L21.2617 13.4216L19.2173 13.7672L16.764 14.1819L14.3107 14.5966L11.8575 15.0113L8.99533 15.4952L6.13318 15.979M6.13318 15.979L6.54206 17.5984H22.0794M8.99533 6.66773L10.222 13.4216M14.7196 6.66773L15.5374 11.9306M21.2617 6.66773L20.035 11.5258",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8575 22.4555C10.8575 23.6826 9.8501 24.6942 8.58646 24.6942C7.32282 24.6942 6.31543 23.6826 6.31543 22.4555C6.31543 21.2284 7.32282 20.2168 8.58646 20.2168C9.8501 20.2168 10.8575 21.2284 10.8575 22.4555Z",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 22.4555C21.4883 23.6826 20.481 24.6942 19.2173 24.6942C17.9537 24.6942 16.9463 23.6826 16.9463 22.4555C16.9463 21.2284 17.9537 20.2168 19.2173 20.2168C20.481 20.2168 21.4883 21.2284 21.4883 22.4555Z",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacket);
export default __webpack_public_path__ + "static/media/backet.741c0c3ae674da44a6d8839fecdbe412.svg";
export { ForwardRef as ReactComponent };